import { rectIntersection, closestCenter } from '@dnd-kit/core';

export function customCollision(args) {
  const pointerCollisions = closestCenter(args);

  // Collision detection algorithms return an array of collisions
  if (pointerCollisions.length > 0) {
    return pointerCollisions;
  }

  // If there are no collisions with the closest center, return rectangle intersections
  return rectIntersection(args);
}
